// extracted by mini-css-extract-plugin
export default {"image":"nX-z","loaded":"oX-z"};